var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54339 8.13135L3.52205 8.96868C3.46432 8.97832 3.41015 9.00298 3.36498 9.0402C3.3198 9.07741 3.28523 9.12586 3.26472 9.18068L1.53339 13.8187C1.36805 14.2453 1.81405 14.652 2.22339 14.4473L14.2234 8.44735C14.3065 8.40585 14.3764 8.34201 14.4253 8.26299C14.4741 8.18398 14.5 8.09292 14.5 8.00001C14.5 7.90711 14.4741 7.81605 14.4253 7.73704C14.3764 7.65802 14.3065 7.59418 14.2234 7.55268L2.22339 1.55268C1.81405 1.34802 1.36805 1.75535 1.53339 2.18135L3.26539 6.81935C3.2858 6.87429 3.32033 6.92288 3.36551 6.96022C3.41069 6.99756 3.46492 7.02232 3.52272 7.03202L8.54405 7.86868C8.57496 7.8741 8.60296 7.89023 8.62314 7.91425C8.64332 7.93827 8.65438 7.96864 8.65438 8.00001C8.65438 8.03139 8.64332 8.06176 8.62314 8.08578C8.60296 8.1098 8.57496 8.12593 8.54405 8.13135H8.54339Z",
    fill: "#E8E13F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.a9f83054.svg";
export { ForwardRef as ReactComponent };